<template>
<div class="body">
  <b-link :to="{name:'eventmanager'}"><b><&nbsp;Back</b></b-link>
  <b-nav tabs align="center"
    >

    <b-nav-item :to="{name:'manage_event',params:{}}"
      exact exact-active-class="active">
        <b>Event</b>
    </b-nav-item>
 
    <b-nav-item :to="{name:'ticket_details',params:{}}"
       v-if="event.groups.length"
       exact exact-active-class="active">
       <b>Tickets</b>
    </b-nav-item>

    <b-nav-item :to="{name:'update_stages',params:{}}"
       v-if="event.groups.length"
       exact exact-active-class="active">
       <b>Stages</b>
    </b-nav-item>

    <b-nav-item :to="{name:'update_sessions',params:{}}"
       v-if="event.groups.length"
       exact exact-active-class="active">
      <b>Sessions</b>
    </b-nav-item>

    <b-nav-item :to="{name:'update_booths',params:{}}"
       v-if="event.groups.length"
       exact exact-active-class="active">
      <b>Booths</b>
    </b-nav-item>

    <b-nav-item :to="{name:'update_networking',params:{}}"
       v-if="event.groups.length"
       exact exact-active-class="active">
      <b>Networking</b>
    </b-nav-item>

    <b-nav-item :to="{name:'update_sponsors',params:{}}"
       v-if="event.groups.length"
       exact exact-active-class="active">
       <b>Sponsors</b>
    </b-nav-item>

    <b-nav-item :to="{name:'update_srep',params:{}}"
       exact exact-active-class="active">
       <b>Sales Reps</b>
    </b-nav-item>

   <b-nav-item :to="{name:'update_registration',params:{}}"
       v-if="event.groups.length"
       exact exact-active-class="active">
       <b>Registration</b>
    </b-nav-item>
   
  </b-nav>

  <div class="subview">
    <router-view :id="this.$route.params.id"></router-view>
  </div>

  <div style="position:fixed;bottom:0;left:0.5rem;font-size:0.8rem;">
    {{ version }}
  </div>  
</div>
</template>

<script>

import utils from "../eventutils";

export default {
  name: "events",
  data() {
    return {
      version: "",
      acc: null,
      event: {sessions:[],groups:[],booths:[],networking:[],stages:[],
              sponsors:[]},
    }
  },
  methods: {
    toast(k,m) {
        let variant="success";
        let delay = 5000;
        if (k == 'err') {
           variant="danger";
           delay = 20000;
        }
        this.$bvToast.toast([
             this.$createElement('div',{style:'display:none'})
          ], {
          title: m,
          variant: variant,
          autoHideDelay: delay,
          appendToast: true
        })
    },
    notify: function(msg) {
      let vue = this;
      if (!vue.event || !vue.event.id) { return; }
      window.wss_send(vx, "adm_event_notify", {
        event: {
          id:vue.event.id,
        },
        msg: msg,
      });
    },
    showconfirm(variant, msg, okcb, errcb) {
        this.inval = ''  // Future use
        this.$bvModal.msgBoxConfirm(msg, {
          title: 'Confirmation',
          size: 'sm',
          buttonSize: 'sm',
          okVariant: variant,
          okTitle: "Edit",
          cancelVariant: "Secondary",
          cancelTitle: "Cancel",
          headerClass: 'p-2 border-bottom-0',
          footerClass: 'p-2 border-top-0',
          centered: true
        })
        .then(value => {
          if (value) {
            okcb && okcb();
          } else {
            errcb && errcb();
          }
        })
        .catch(err => {
            errcb && errcb();
        })
      }
  },
  beforeDestroy() {
    let vue = this;
     if (vue.event && vue.event.id) {
       window.wss_send(vx, "adm_event_rem_notify", {event:{id:vue.event.id}});
     }
       window.wss_clr_routes(window.vx,"eventman");
  },
  mounted() {
    $("body").removeClass("setbackground");
    let vue = this;
    vue.version = vx.about.site_version;
    vue.acc = vue.$router.currentRoute.params.acc;

    window.wss_open(vx, {
      acc: vue.acc,
      uid: vx.user? vx.user.id: "not set",
      routes_id: "eventman",
      routes: {
        auth_me: function(msg) {
           if (msg.data.error) {
              vue.$router.push({name:'eventmanager'});
              return;
           }
           if (!vue.event.id) {
              if (vue.$route.params.id) {
                 window.wss_send(vx, "adm_event_list", {rtag: "eventman",
                    event: { id: vue.$route.params.id}});
              }
           }
        },
        evnotify: function(msg) {
         // msg.em == (server set) Email of sender
         // msg.full_admin == (server set) true if sender is an admin
         // msg.code == (server set)
         //     "add_notify": (automatically sent) sender joined
         //     "rem_notify": (automatically sent) sender left
         //     "user_msg": explicitly sent message sent
         // msg.data.*  any other fields came from the sender
        },
        adm_event_list: function(msg) {
	    if (msg.rtag != "eventman") return;
	    if ((msg.data.error) ||
		(msg.data.events.length == 0)) {
                vue.$router.push({name:'eventmanager'});
                return;
	    }
	    if (msg.data.events[0].id == vue.$route.params.id) {
                if (!msg.data.events[0].can_edit) {
                  vue.$router.push({name:'eventmanager'});
                  return;
                }
         vue.event = utils.remote_to_local(msg.data.events[0]);
         window.wss_send(vx, "adm_event_add_notify",{event:{id:vue.event.id}});

	    }
        },
      }
    });
  }
};
</script>

<style lang="scss" scoped>
.body {
   background-color:white;
}
.subview {
}
</style>

